module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_minamisouma-7969888b0f467d9dfd80fa1582a852af.jpg";